<div class="wrapper-manage-queues">
    <h6 class="mb-3">Queues</h6>
    <div class="toolbar">
        <button
            pButton
            icon="fa-regular fa-gears"
            label="Resolve Queue"
            class="cv-queues-button p-button-secondary p-button-outlined"
            (click)="openResolveDialog()"
        ></button>
        <button
            pButton
            icon="fa-regular fa-circle-plus"
            label="New Queue"
            class="cv-queues-button p-button-secondary p-button-outlined"
            (click)="newQueue()"
        ></button>
        <cv-queue-searchbar (searchQueryEmitter)="updateSearch($event)"></cv-queue-searchbar>
    </div>

    <ag-grid-angular
        #grid
        class="ag-theme-material mt-2 p-component"
        (gridReady)="onInitializeGrid($event)"
        (gridSizeChanged)="resizeToFitColumns()"
        (rowDataChanged)="onRowDataChanged($event)"
        [pagination]="true"
        [suppressPaginationPanel]="true"
        [gridOptions]="gridOptions"
        [domLayout]="'autoHeight'"
        [rowData]="queues"
    >
    </ag-grid-angular>

    <cv-grid-pagination [pagination]="pagination" (onPaginationChange)="onPaginationChange($event)">
    </cv-grid-pagination>
</div>
<p-toast></p-toast>
<p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
